import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueWorkflow1Route: InvariantJiraRoute = {
	name: 'global-settings-issues-workflows-pages',
	path: '/jira/settings/issues/workflows',
};
